// NB: We don't know all the possible categories/headings for level 4, so we need to add new icons as we encounter new headings. This is a bit of a hack, but it works for now.

import {
    AirplaneIcon,
    BicycleIcon,
    BoatIcon,
    BusIcon,
    CarIcon,
    MotorcycleIcon,
    TramIcon,
    TruckIcon,
} from "@navikt/aksel-icons";

export const ChartIcon: React.FC<{ label: string }> = ({ label }) => {
    // Godstransport > Vei
    if (label === "Varebil") {
        return <TruckIcon fontSize={30} aria-hidden="true" />;
    } else if (label === "Lastebil") {
        return <TruckIcon fontSize={30} aria-hidden="true" />;
    }
    // Godstransport > Sjøfart
    else if (label === "Stykkgodsskip") {
        return <BoatIcon fontSize={30} aria-hidden="true" />;
    } else if (label === "Bulkskip") {
        return <BoatIcon fontSize={30} aria-hidden="true" />;
    } else if (label === "Andre lasteskip") {
        return <BoatIcon fontSize={30} aria-hidden="true" />;
    }
    // Godstransport > Fiskeri
    else if (label === "Kystgående fiskefartøy") {
        return <BoatIcon fontSize={30} aria-hidden="true" />;
    } else if (label === "Havgående fiskefartøy") {
        return <BoatIcon fontSize={30} aria-hidden="true" />;
    }
    // Godstransport > Jernbane
    // Persontransport > Bane
    else if (label === "Tog") {
        return <TramIcon fontSize={30} aria-hidden="true" />;
    }
    // Godstransport > Luft
    // Persontransport > Luft
    else if (label === "Fly") {
        return <AirplaneIcon fontSize={30} aria-hidden="true" />;
    }
    // Persontransport > Vei
    else if (label === "Personbil") {
        return <CarIcon fontSize={30} aria-hidden="true" />;
    } else if (label === "Buss") {
        return <BusIcon fontSize={30} aria-hidden="true" />;
    } else if (label === "Motorsykkel") {
        return <MotorcycleIcon fontSize={30} aria-hidden="true" />;
    }
    // Persontransport > Sjøtransport
    else if (label === "Passasjerskip") {
        return <BoatIcon fontSize={30} aria-hidden="true" />;
    }
    // Persontransport > Bane
    else if (label === "Trikk og T-bane") {
        return <TramIcon fontSize={30} aria-hidden="true" />;
    }
    // Persontransport > Gange og sykkel
    else if (label === "Gange og sykkel") {
        return <BicycleIcon fontSize={30} aria-hidden="true" />;
    } else {
        return null;
    }
};
